export { default } from './SpecialPagesViewContainer';



// WEBPACK FOOTER //
// ./src/components/SpecialPages/containers/SpecialPagesViewContainer/index.js